import axios from 'axios';
import { ExceptionEnum } from './exception.enum';

function readMessageField(data: unknown): string | null {
  if (typeof data !== 'object' || data === null || !('message' in data)) {
    return null;
  }

  const { message } = data as { message: unknown };

  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message) && typeof message[0] === 'string') {
    return message[0];
  }

  return null;
}

export function extractExceptionCode(error: unknown): ExceptionEnum | null {
  if (typeof error === 'string') {
    return error as ExceptionEnum;
  }

  if (axios.isAxiosError(error)) {
    const message = readMessageField(error.response?.data);
    if (message) {
      return message as ExceptionEnum;
    }
  }

  if (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as { message: unknown }).message === 'string'
  ) {
    return (error as { message: string }).message as ExceptionEnum;
  }

  return null;
}
